import axios from 'axios';
import Config from '../constants/config';

let instance = axios.create({
    baseURL:  Config.url
});

instance.interceptors.response.use((response) =>
    {
        return response;
    },
    function (error) {
        if (parseInt(error.response.status) === 401) {
            if (window.location.pathname.toLowerCase() !== "/login") {
                // localStorage.clear();
                // sessionStorage.clear();
                // localStorage.setItem("lastPath", window.location.pathname);
                // window.location.href = "/Login";
            }
        }
        return Promise.reject(error);
    });

export default instance;